import { SchedulerDayColumn, ShiftSiblingData } from '@lp/features/Scheduler/types';
import { DayCell } from '@lp/features/Scheduler/components';
import { OMSShiftCell, OMSShiftEmptyCell } from '@lp/features/Scheduler/SchedulerOMS/components';
import { OMSShift, OMSShiftSelectPayload } from '@/api/apis/resources/schedule';

type OMSDayCellProps = {
  column: SchedulerDayColumn;
  shiftData: OMSShift;
  siblingData?: ShiftSiblingData;
  isEditable: boolean;
  canReset: boolean;
  highlight?: boolean;
  canUnblock?: boolean;
  onShiftChange: (shiftPayload?: OMSShiftSelectPayload) => void;
  onUnblock?: () => void;
  getResettableSlot?: (slotIndex: number) => boolean;
};

export const OMSDayCell = ({
  column,
  shiftData,
  siblingData,
  isEditable,
  canReset,
  highlight,
  canUnblock,
  onShiftChange,
  onUnblock,
  getResettableSlot,
}: OMSDayCellProps) => {
  const readonly = !isEditable || !column.isCurrentMonth;

  return (
    <DayCell
      active={column.isSelectedDay}
      highlight={highlight}
      hasPrev={siblingData?.hasPrev}
      hasNext={siblingData?.hasNext}
    >
      {shiftData ? (
        <OMSShiftCell
          shiftData={shiftData}
          siblingData={siblingData}
          lighten={!column.isCurrentMonth}
          readonly={readonly}
          canReset={canReset}
          canUnblock={canUnblock}
          onShiftChange={onShiftChange}
          onUnblock={onUnblock}
          getResettableSlot={getResettableSlot}
        />
      ) : (
        !readonly && <OMSShiftEmptyCell onShiftChange={onShiftChange} />
      )}
    </DayCell>
  );
};
